// src/App.jsx
import { useEffect, useState } from "react";

export function useNoCaptcha() {
    const [recaptchaReady, setRecaptchaReady] = useState(false);

    const start = async () => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_CAPTCHA_CLIENT_ID}`;
            script.addEventListener("load", () => {
                setRecaptchaReady(true);
                resolve(true);
            });
            document.body.appendChild(script);
        })
    }

    const getNoCaptcha = async (action: string) => {
        try {
            await start();
            const wd: any = window;
            const token = await wd.grecaptcha.execute(process.env.REACT_APP_CAPTCHA_CLIENT_ID, {
                action,
            });
            setTimeout(clear, 1200);
            return token;
        } catch (err) {
            console.log(err);
            await new Promise((resolve) => { setTimeout(resolve, 1000); })
            return getNoCaptcha(action);
        }
    };

    const clear = () => {
        // Remove the script
        const scripts = document.querySelectorAll('script[src*="recaptcha"]');
        scripts.forEach((s) => s.parentNode?.removeChild(s));

        // Remove grecaptcha instances
        const wd: any = window;
        if (wd.grecaptcha) {
            delete wd.grecaptcha;
        }

        // Optional: remove rendered badge if exists
        const badges = document.querySelectorAll(".grecaptcha-badge");
        badges.forEach(b => b.remove());

        setRecaptchaReady(false);
    };


    return {
        ready: recaptchaReady,
        getNoCaptcha,
        clear,
    }
}
